import { Svg } from '~shared/ui';

import { USERS_LIST_LIMIT } from './use-users';

type UsersPagesProps = {
	page: number;
	total: number;
	onChange: (val: number) => void;
};

export function UsersPages({ page, total, onChange }: UsersPagesProps) {
	const pagecount =
		total % USERS_LIST_LIMIT > 0 ? parseInt(String(total / USERS_LIST_LIMIT)) + 1 : total / USERS_LIST_LIMIT;

	const pages: { page: number; active: boolean }[] = [];
	for (let index = 1; index <= pagecount; index++) {
		pages.push({ page: index, active: page + 1 === index });
	}

	if (pages.length <= 0) return null;

	const show = page + 1;

	const handleBack = () => {
		onChange(page - 1);
	};

	const handleNext = () => {
		onChange(page + 1);
	};

	return (
		<div className="users-pages">
			<div className="pagination-counter">
				Показано {show} из {pagecount}
			</div>
			<nav className="pagination">
				{show > 1 && (
					<a className="pagination__item pagination__item--arrow" title="Назад" onClick={handleBack}>
						<Svg name="left" />
					</a>
				)}

				{pages.map(item => {
					const handleClick = () => {
						onChange(item.page - 1);
					};

					if (item.active) {
						return (
							<span key={item.page} className="pagination__item active">
								{item.page}
							</span>
						);
					}

					return (
						<a key={item.page} onClick={handleClick} className="pagination__item">
							{item.page}
						</a>
					);
				})}

				{show < pagecount && (
					<a onClick={handleNext} className="pagination__item pagination__item--arrow" title="Вперед">
						<Svg name="right" />
					</a>
				)}
			</nav>
		</div>
	);
}
